import { FC } from 'react';
import { Redirect, useLocation, useParams } from 'react-router-dom';

import { isNotNullish } from '@app/helpers/predicate';

import useCart from '../hooks/useCart';

/*
TODO: We currently show the option to cancel an in progress transaction.
We need to determine if this is still relevant for the new shop, and if so use this HOC to show the cancel transaction modal
*/
const CartStatusCheck: FC = ({ children }) => {
  const { search } = useLocation();
  const { language } = useParams<{ language: string }>();
  const { items, loading: cartLoading } = useCart();

  if (!cartLoading && !items?.filter(isNotNullish).length) {
    return <Redirect to={{ search, pathname: `/${language}/shop/cart/` }} />;
  }

  return cartLoading ? null : <>{children}</>;
};

export default CartStatusCheck;
